export default {
  SET_DEALERS: (state, data) => {
    state.dealers = data;
  },
  SET_DEALER: (state, data) => {
    state.dealer = data;
  },
};
